import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, LinearProgress, Typography } from '@mui/material';

import { useMountEffect, useSettings, Utils } from 'app/main/components';
import TotemCommunicationItem from '../components/items/TotemCommunicationItem';

export default function TotemCommunicationSection() {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const [isLoading, setIsLoading] = React.useState(false);
	const [items, setItems] = React.useState<any[]>([]);

	useMountEffect(() => {
		setIsLoading(true);
		let rows = 0;
		const list: any[] = [];
		Utils.executeApi.get({
			url: `api/hrm/communications?nPage=1&nRows=25`,
			dispatch,
			successHandler: response => {
				let page = 1;
				rows = response.data.n_record;
				if (rows > 0) {
					list.push(...response.data.list);
					rows -= 25;
					while (rows > 0) {
						page += 1;
						rows -= 25;
						Utils.executeApi.get({
							url: `api/hrm/communications?nPage=${page}&nRows=25`,
							dispatch,
							successHandler: res => list.push(...res.data.list)
						});
					}
					setItems(list);
				}
				setIsLoading(false);
			}
		});
	});

	if (!isLoading) {
		return (
			<div className="h-full p-24">
				<Typography className="mb-16 font-600" variant="h5">
					{t('TOTEM_HEADER_NEWS_TITLE')}
				</Typography>
				{items.length > 0 ? (
					<Grid container spacing={2}>
						{items.map((item, i) => (
							<Grid key={i} size={{ lg: 3, md: 4, sm: 6, xs: 12 }}>
								<TotemCommunicationItem model={item} />
							</Grid>
						))}
					</Grid>
				) : (
					<Grid container justifyContent="center">
						<Grid>
							<Typography variant="h6">{t('NO_COMMUNICATIONS_TITLE').toUpperCase()}</Typography>
						</Grid>
					</Grid>
				)}
			</div>
		);
	}

	return <LinearProgress />;
}
